// One help popover is open at a time across the whole page (and across React roots), so the open key lives
// in a module-level store rather than in a context a portal or second root could miss.
let openKey: string | null = null
const listeners = new Set<() => void>()

export function subscribeFgHelp(listener: () => void) {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
export const readOpenFgHelp = () => openKey
export function setOpenFgHelp(key: string | null) {
  if (openKey === key) return
  openKey = key
  for (const listener of [...listeners]) listener()
}
/** Closes whichever help popover is open. Used when the page unmounts and by tests. */
export const closeAllFgHelp = () => setOpenFgHelp(null)

export const FG_HELP_SHEET_MAX_WIDTH = 639
export interface FgHelpPosition { top: number; left: number; width: number; maxHeight: number; placement: 'below' | 'above' }
/**
 * Places a popover of the measured size next to its button: below when it fits (or when there is more room
 * below than above), otherwise above, clamped so it never leaves the viewport on any edge — including the
 * top, which an anchor scrolled off the top of the page would otherwise drag it past.
 */
export function computeFgHelpPosition(anchor: { top: number; bottom: number; left: number; width: number }, size: { width: number; height: number }, viewport: { width: number; height: number }, gap = 8, margin = 12): FgHelpPosition {
  const width = Math.max(0, Math.min(size.width, viewport.width - margin * 2))
  const centred = anchor.left + anchor.width / 2 - width / 2
  const left = Math.min(Math.max(margin, centred), Math.max(margin, viewport.width - margin - width))
  const roomBelow = viewport.height - anchor.bottom - gap - margin
  const roomAbove = anchor.top - gap - margin
  const placement = size.height <= roomBelow || roomBelow >= roomAbove ? 'below' : 'above'
  const maxHeight = Math.max(120, placement === 'below' ? roomBelow : roomAbove)
  const height = Math.min(size.height, maxHeight)
  const top = Math.max(margin, placement === 'below' ? anchor.bottom + gap : anchor.top - gap - height)
  return { top, left, width, maxHeight, placement }
}
